import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Organicé todo mi cuatrimestre en una tarde. Las plantillas de apuntes me ahorran horas de idas y vueltas cada semana. Aprobé 3 materias seguidas.',
  name: 'Martín G.',
  location: 'Córdoba · Ingeniería',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/2c2c0595-1eea-431f-a991-351bd2295f48.jpg'
}, {
  quote: 'El protocolo anti-bloqueo por fin funciona. El tomo de manejo de ansiedad es el más útil para entender cómo realmente rendir un final oral sin congelarse.',
  name: 'Valentina P.',
  location: 'Rosario · Derecho',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/7cf62f48-efdb-43df-a224-015d4d12f8b2.jpg'
}, {
  quote: 'Mis notas no dejaron de mejorar. El Tomo de Mnemotecnia vale absolutamente cada peso que pagué. Pasé de recursar a aprobar todo en un cuatrimestre.',
  name: 'Camila R.',
  location: 'Buenos Aires · Medicina',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/0b522287-cfe4-4ccf-9781-0c38d2e3d235.jpg'
}];
export function Testimonials() {
  return <section aria-label="Testimonios" className="bg-ink" data-id="element-155" data-mp="m6m7hmj6ay8e">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20 pt-[47px]" data-id="element-156" data-mp="78a9nck2djfn">
        <h2 className="text-center font-display text-3xl font-black text-white sm:text-4xl" data-id="element-157" data-mp="c6vcljqpah7s">
          💬 Lo que dicen los que ya lo aplicaron
        </h2>
        <div className="mt-10 grid w-full grid-cols-1 gap-5 sm:mt-12 md:grid-cols-3 md:gap-6" data-id="element-158" data-mp="zxr3menc18dz">
          {testimonials.map((t, i) => <motion.figure key={t.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="flex min-h-[230px] flex-col rounded-2xl border border-white/10 bg-ink-2 p-6 sm:min-h-[250px]" data-id="element-159" data-mp="14xlq8602rbt8" data-mpi={i}>
              <div className="flex gap-0.5 text-gold" data-id="element-160" data-mp="1xi0o3ch89zzp">
                {Array.from({
              length: 5
            }).map((_, k) => <StarIcon key={k} className="h-4 w-4 fill-current" data-id="element-161" data-mp="1siecf7h1srt0" data-mpi={k} />)}
              </div>
              <blockquote className="mt-4 flex-1 text-[15px] leading-relaxed text-white/80" data-id="element-162" data-mp="1oh2jot2vnqgl">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-white/10 pt-4" data-id="element-163" data-mp="1jhpui1oja7au">
                <img src={t.img} alt={t.name} className="h-11 w-11 rounded-full object-cover ring-2 ring-gold/50" data-id="element-164" data-mp="1ekpo1pnrv2j7" />
                <div data-id="element-165" data-mp="19qbqbgln0jbd">
                  <div className="text-sm font-bold text-white" data-id="element-166" data-mp="14tbkn6sp9iks">{t.name}</div>
                  <div className="text-xs text-white/50" data-id="element-167" data-mp="14r8xcuixm3jr">📍 {t.location}</div>
                </div>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}